<template>
  <v-card>
    <v-toolbar card color="warning" dark>
      <v-toolbar-title class="body-2">IMPORTAR PRODUCTOS</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn @click="$emit('close-csv')" icon>
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <v-form>
        <v-layout row wrap>
          <v-flex md12 xs12>
            <v-select
              :error-messages="errors.collect('laboratory')"
              :items="laboratories"
              data-vv-name="laboratory"
              label="Laboratorio"
              no-data-text="Datos no disponibles"
              required
              v-model="form.labId"
              v-validate="'required'"
            ></v-select>
          </v-flex>
          <v-flex lg12 sm12>
            <upload-btn @clicked="onFilePicked"></upload-btn>
            <div class="v-text-field__details" v-if="form.files == null">
              <div class="v-messages theme--light error--text">
                <div class="v-messages__wrapper">
                  <div class="v-messages__message">El archivo es requerido</div>
                </div>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card-text>
    <v-card-actions class="pb-3">
      <v-spacer></v-spacer>
      <v-btn @click="uploadFile" color="warning">Salvar</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import UploadButton from './FileUpload'

export default {
  components: {
    'upload-btn': UploadButton,
  },
  data: () => ({
    laboratories: [],
    form: {
      labId: '',
      files: null,
    },
  }),
  created() {
    this.$store.dispatch('laboratories/getAll', {}).then(response => {
      const data = response.items
      for (let index = 0; index < data.length; index += 1) {
        this.laboratories.push({
          text: data[index].name,
          value: data[index].id,
        })
      }
    })
  },
  methods: {
    onFilePicked(file) {
      this.form.files = file
    },
    uploadFile() {
      this.$validator.validateAll().then(result => {
        if (result && this.form.files) {
          this.$emit('close-csv')
          this.$emit('loading-show')
          this.$store.dispatch('products/import', this.form).then(response => {
            setTimeout(() => {
              this.$emit('upload-ready', {
                labId: this.form.labId,
                file: response.data.file,
              })
            }, 3000)
          })
        }
      })
    },
  },
}
</script>
